import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { EncuestaSatisfaccionProps, PreguntaSatisfaccion } from 'src/common/encuesta';
import { PreguntaSatisfaccionActions, PreguntaSatisfaccionActionTypes } from './pregunta-satisfaccion.actions';

export interface PreguntaSatisfaccionState extends EntityState<PreguntaSatisfaccion> {
	preguntaReady: boolean,
	encuestaReady: boolean,
	encuestaSaved: boolean,
	encuestaProps: EncuestaSatisfaccionProps
}

export const preguntaSatisfaccionAdapter: EntityAdapter<PreguntaSatisfaccion> = createEntityAdapter<PreguntaSatisfaccion>();

const initialPreguntaSatisfaccionState: PreguntaSatisfaccionState = preguntaSatisfaccionAdapter.getInitialState({
	preguntaReady: true,
	encuestaReady: true,
	encuestaSaved: false,
	encuestaProps: null
});


export function preguntaSatisfaccionReducer( state: PreguntaSatisfaccionState = initialPreguntaSatisfaccionState, action: PreguntaSatisfaccionActions ): PreguntaSatisfaccionState {
	switch( action.type ) {
		case PreguntaSatisfaccionActionTypes.PreguntasRequested:
			return { ...state, preguntaReady: false };
		case PreguntaSatisfaccionActionTypes.PreguntasLoaded:
			let preguntas: PreguntaSatisfaccion[] = action["payload"];
			state = preguntaSatisfaccionAdapter.removeAll( state );
			return preguntaSatisfaccionAdapter.addMany( preguntas, { ...state, preguntaReady: true } );
		case PreguntaSatisfaccionActionTypes.PreguntasCancelled:
			return { ...state, preguntaReady: true };

		case PreguntaSatisfaccionActionTypes.AddEncuestaRequested:
			return { ...state, encuestaReady: false };
		case PreguntaSatisfaccionActionTypes.AddEncuestaAccepted:
			let encuestaProps: EncuestaSatisfaccionProps = action["payload"];
			return { ...state, encuestaReady: true, encuestaSaved: true, encuestaProps };
		case PreguntaSatisfaccionActionTypes.AddEncuestaCancelled:
			return { ...state, encuestaReady: true, encuestaSaved: false };

		case PreguntaSatisfaccionActionTypes.EncuestaPropsRequested:
			return { ...state, encuestaReady: false };
		case PreguntaSatisfaccionActionTypes.EncuestaPropsLoaded:
			let props: EncuestaSatisfaccionProps = action["payload"];
			return { ...state, encuestaProps: props, encuestaReady: true };
		case PreguntaSatisfaccionActionTypes.EncuestaPropsAlreadyLoaded:
		case PreguntaSatisfaccionActionTypes.EncuestaPropsCancelled:
			return { ...state, encuestaReady: true };

		default:
			return state;
	}
}

export const {
	selectAll
} = preguntaSatisfaccionAdapter.getSelectors();